var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssurance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#134A81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M27.15 20.099h-.575v-3.495A4.609 4.609 0 0021.972 12a4.609 4.609 0 00-4.604 4.604v3.495h-.575c-.99 0-1.793.802-1.793 1.792v8.316c0 .99.803 1.793 1.793 1.793H27.15c.99 0 1.793-.803 1.793-1.793v-8.316c0-.99-.803-1.792-1.793-1.792zm-8.171-3.495a2.996 2.996 0 012.993-2.993 2.995 2.995 0 012.992 2.993v3.495H18.98v-3.495zm3.91 9.355v2.238a.917.917 0 11-1.834 0v-2.238a1.628 1.628 0 111.834 0z"
  }))));
}
export default SvgAssurance;